<template>
	<div>
		<compWrapper :title="$t('fbb.costmanage.base_info', { defaultValue: '基础信息' })" theme="primary">
			<compFormQuery ref="accountform" class="margin-top-15" :formdata="getBase" :value="formData"></compFormQuery>
		</compWrapper>
		<compWrapper :title="$t('fbb.billing.feedetail', { defaultValue: '费用明细' })" theme="primary">
			<vTableSimple class="margin-15" :columns="getColumns" :data="datalist" border></vTableSimple>
		</compWrapper>
		<compLog wrapper :data="logList" :columns="getLogColumns"></compLog>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>
<script>
import { HttpGetBillingOrderOne, HttpGetWareList, HttpBillManageLog, HttpGetBillingOrderList } from '@/service/billing';
import { HttpBillServiceCostList, HttpBillMaterialCostList } from '@/service/billing';
import { mapGetters } from 'vuex';
export default {
	components: {
		compWrapper: () => import('@components/templates/wrapper'),
		compFormQuery: () => import('@components/templates/formquery'),
		compLog: () => import("@components/templates/log"),
	},
	data() {
		return {
			loading: false,
			formData: {},
			id: this.$route.query.id,
			type: this.$route.params.type,
			datalist: [],
			logList: [],
		};
	},
	created() {
		this.getDetail();
	},
	computed: {
		...mapGetters('dictionary', ['getBillcusorgList', 'getCusproductList']),
		...mapGetters('common', ['getStatusList', 'getTypeList', 'getBussinessTypeList', 'getOrderOneTypes']),
		getBase() {
			return [

				{
					label: this.$t('global.common.organization', { defaultValue: '组织' }),
					key: 'organizationId',
					options: this.getBillcusorgList,
				},
				{
					label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
					key: 'orgWarehouseCode',
				},
				{
					label: this.$t('global.common.currency', { defaultValue: '币种' }),
					key: 'currency',
				},
				{
					label: this.$t('global.common.status', { defaultValue: '状态' }),
					key: 'status',
					options: this.getStatusList,
				},
				{
					label: this.$t('fbb.costmanage.work_type', { defaultValue: '业务类型' }),
					key: 'businessType',
					options: this.getBussinessTypeList,
				},
				{
					label: this.$t('fbb.adjustment.bill_type', { defaultValue: '费用类型' }),
					key: 'type',
					options: this.getTypeList,
				},
				{
					label: this.$t('fbb.costmanage.cost_order_type', { defaultValue: '计费单据类型' }),
					key: 'billingCategoryType',
					options: this.getOrderOneTypes,
				},
				{
					label: this.$t('fbb.accountmanage.one_level_type', { defaultValue: '一级分类' }),
					key: 'firstBillingCategoryName',
				},
				{
					label: this.$t('fbb.adjustment.bill_no', { defaultValue: '计费单号' }),
					key: 'orderNo',
				},
				{
					label: this.$t('fbb.costmanage.distinguish_number', { defaultValue: '识别号' }),
					key: 'sourceNo',
				},
				{
					label: 'Tracking No',
					key: 'trackingNo',
				},
				{
					label: this.$t('global.common.line', { defaultValue: '项目' }),
					key: 'lineName',
				},
				{
					label: this.$t('global.common.notes', { defaultValue: '备注' }),
					key: 'remark',
				},

			]
		},
		//按照类型获取 columns
		getColumns() {
			const typeMap = {
				1: 'getWarehouseColumns',
				3: 'getServiceColumns',
				5: 'getMaterialColumns',
			};
			return this[typeMap[this.formData.type]]
		},
		//查看仓库作业费
		getWarehouseColumns() {
			return [
				{
					title: this.$t('fbb.accountmanage.one_level_type', { defaultValue: "一级分类" }),
					key: 'firstBillingCategoryName'
				},
				{
					title: this.$t('fbb.accountmanage.two_level_type', { defaultValue: "二级分类" }),
					key: 'secondBillingCategoryName'
				},
				{
					title: this.$t('fbb.accountmanage.three_level_type', { defaultValue: "三级分类" }),
					key: 'thirdBillingCategoryName'
				},
				{
					title: this.$t('fbb.accountmanage.feilv', { defaultValue: "费率" }),
					key: 'rate'
				},
				{
					title: this.$t('fbb.accountmanage.amount', { defaultValue: "数量" }),
					key: 'count'
				},
				{
					title: this.$t('fbb.costmanage.take_goods_diffcult_level', { defaultValue: '拣货难度系数' }),
					key:'otherCoefficient'
				},
				{
					title: this.$t('fbb.billmanage.total_cost', { defaultValue: "总费用" }),
					key: 'cost'
				},
				{
					title: this.$t('fbb.inbound.container_no', { defaultValue: "集装箱号" }),
					key: 'containerNo'
				},
				{
					title: "SKU",
					key: 'relSku'
				},
			]
		},
		// 查看增值服务费
		getServiceColumns() {
			return [
				{
					title: this.$t('fbb.costmanage.things', { defaultValue: '事务项' }),
					key: 'transactionCode'
				},
				{
					title: this.$t('fbb.accountmanage.feilv', { defaultValue: '费率' }),
					key: 'baseRate'
				},
				{
					title: this.$t('fbb.accountmanage.cost', { defaultValue: '成本' }),
					key: 'cost',
					render(h, { row }) {
						return row.billingSourcesType == 'FIXED' ? '' : row.cost
					}
				},
				{
					title: this.$t('fbb.accountmanage.amount', { defaultValue: '数量' }),
					key: 'qty'
				},
				{
					title: this.$t('fbb.billmanage.total_cost', { defaultValue: '总费用' }),
					key: 'totalCost'
				},
				{
					title: 'SKU',
					key: 'sku'
				},
				{
					title: this.$t('global.common.line', { defaultValue: '项目' }),
					key: 'lineId',
					render: (h, { row }) => {
						const data = this.getCusproductList.find(item => item.value == row.lineId) || {};
						return data.label
					},
				},
				{
					title: this.$t('global.common.notes', { defaultValue: '备注' }) + '/Invoice no',
					key: 'invoiceRemark'
				},
				{
					title: this.$t('global.common.notes', { defaultValue: '备注' }) + '/Tracking no',
					key: 'trackingRemark'
				},
			]
		},
		//查看包材计费单
		getMaterialColumns() {
			return [
				{
					title: this.$t('fbb.costmanage.material', { defaultValue: "包材" }),
					key: 'materialName'
				},
				{
					title: this.$t('fbb.accountmanage.feilv', { defaultValue: "费率" }),
					key: 'baseRate'
				},
				{
					title: this.$t('fbb.accountmanage.amount', { defaultValue: "数量" }),
					key: 'qty'
				},
				{
					title: this.$t('fbb.billmanage.total_cost', { defaultValue: "总费用" }),
					key: 'cost'
				},
				{
					title: this.$t('global.common.currency', { defaultValue: "币种" }),
					key: 'currency'
				},
			]
		},
		getLogColumns() {
			return [
				{
					title: "No",
					type: 'index'
				},
				{
					title: this.$t('global.common.operate_type', { defaultValue: "操作类型" }),
					// key:'operateType'
					render(h, { row }) {
						switch (row.operateType) {
							case 0: return this.$t('global.common.create', { defaultValue: '创建' }); break;
							case 1: return this.$t('global.datepicker.confirm', { defaultValue: '确认' }); break;
							case 2: return this.$t('fbb.alloment.back_to_normal', { defaultValue: '忽略异常' }); break;
						}
					},
				},
				{
					title: this.$t('fbb.costmanage.explain', { defaultValue: "说明" }),
					key: 'remark'
				},
				{
					title: this.$t('global.common.operator', { defaultValue: "操作人" }),
					key: 'createdName'
				},
				{
					title: this.$t('global.common.operate_time', { defaultValue: "操作时间" }),
					key: 'createdAt'
				},
			]
		}

	},
	methods: {
		//查看仓库作业费
		getWarehouseDetail() {
			this.loading = true;
			HttpGetWareList({
				'search[EQ_billingOrderId]': this.id,
				page: 1,
				rows: 1000,
			}).then(res => {
				this.loading = false;
				this.datalist = res.data.content
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(err.message);
			})
		},
		//查看增值服务费
		getServiceDetail() {
			HttpBillServiceCostList({ billOrderId: this.id }).then(res => {
				this.datalist = res.data
			}).catch(err => {
				this.$VMessage.error(err.message);
			})
		},
		//查看包材计费单
		getMaterialDetail() {
			HttpBillMaterialCostList({ billOrderId: this.id }).then(res => {
				this.datalist = res.data;
			}).catch(err => {
				this.$VMessage.error(err.message);
			})
		},
		getCostDetail() {
			const typeMap = {
				1: 'getWarehouseDetail',
				3: 'getServiceDetail',
				5: 'getMaterialDetail',
			};
			const ajax = typeMap[this.formData.type];
			if (ajax) this[ajax]();
		},
		getDetail() {
			// 获取基础信息
			HttpGetBillingOrderList({
				'search[EQ_id]': this.id,
				page: 1,
				rows: 1000,
			}).then(res => {
				// let { organizationId, orgWarehouseCode, currency, status, businessType, type, billingCategoryType, firstBillingCategoryName, orderNo, trackingNo, lineName, remark, sourceNo } = res.data.content[0];
				this.formData = res.data.content[0];
				this.getLogDetail();
				this.getCostDetail();
			}, err => {
				this.$VMessage.error(err.message);
			})


		},

		getLogDetail() {
			HttpBillManageLog({
				'search[EQ_orderId]': this.id,
				// 'search[EQ_orderNo]': this.formData.orderNo,
				'search[EQ_orderType]': 1000,
				page: 1,
				rows: 1000,
			}).then(res => {
				this.logList = res.data.content
			}, err => {
				this.$VMessage.error(err.message);
			})
		}
	}
};
</script>
